import {StepTypeRect} from '@blesk-frontend/api';

/**
 *
 * @param ctx
 * @param rect
 * @param canvas
 */
export const drawBlur = (
  ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
  rect: StepTypeRect,
  canvas: HTMLCanvasElement,
) => {
  const x = rect.x;
  const y = rect.y;
  const width = rect.width;
  const height = rect.height;

  ctx.filter = `blur(${3}px)`;
  ctx.drawImage(canvas, x, y, width, height, x, y, width, height);
  ctx.drawImage(canvas, x, y, width, height, x, y, width, height);
  ctx.drawImage(canvas, x, y, width, height, x, y, width, height);
  ctx.drawImage(canvas, x, y, width, height, x, y, width, height);
  ctx.drawImage(canvas, x, y, width, height, x, y, width, height);
  ctx.drawImage(canvas, x, y, width, height, x, y, width, height);
  ctx.drawImage(canvas, x, y, width, height, x, y, width, height);
  ctx.drawImage(canvas, x, y, width, height, x, y, width, height);
  ctx.drawImage(canvas, x, y, width, height, x, y, width, height);
  ctx.drawImage(canvas, x, y, width, height, x, y, width, height);
};
